import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils/unwrapResponse'
import {
  APIErrorResponse,
  Quotation,
  PostQuotationDetachProject,
} from '@/types'

export const usePostQuotationDetachProject = (): UseMutationResult<
  Quotation,
  APIErrorResponse,
  PostQuotationDetachProject
> => {
  const client = useApiClient()

  return useMutation((params) =>
    client
      .post(`/quotations/${params.id}/detach_project/`)
      .then(unwrapResponse)
      .catch(unwrapErrorResponse)
  )
}
